require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-richard-haddlesey.json") })
        }
      }, "path---authors-richard-haddlesey");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-richard-haddlesey!./.cache/json/authors-richard-haddlesey.json
// module id = 1329
// module chunks = 231608221292675